import React, { useEffect, useState } from "react";

const Cart = () => {
  const [count, setCount] = useState(0);
  // useEffect(() => {
  //   console.log("count", count);
  // }, [count]);

  useEffect(() => {
    const { Snipcart } = window;
    if (!Snipcart) return;

    document.addEventListener("snipcart.ready", function () {
      // Snipcart.setLang("fr");
      // Snipcart.api.session.setLanguage("fr");
    });

    Snipcart.events.on("snipcart.initialization.error", () => {
      // console.log("Failed to initialize Snipcart");
    });

    Snipcart.events.on("item.added", cartItem => {
      // console.log("item.added", Snipcart.store.getState().cart.items.count);
      setCount(Snipcart.store.getState().cart.items.count);
    });
    Snipcart.events.on("item.removed", cartItem => {
      // console.log("item.removed", Snipcart.store.getState().cart.items.count);
      setCount(Snipcart.store.getState().cart.items.count);
    });
  }, []);

  return (
    <div className='cart x'>
      <button className='snipcart-checkout'>
        <span>PANIER</span>
        {count > 0 && <span className='snipcart-items-count'> ({count})</span>}
      </button>
      {/* <span class="snipcart-total-price"></span> */}
    </div>
  );
};

export default Cart;
